export default {
  title: {
    cashOutManagement: 'Cash Out Management'
  },
  menu: {
    cashOutManagement: 'Cash Out Management'
  },
  label: {
    startDate: 'Start Date',
    endDate: 'End Date',
    to: 'To',
    rewardType: 'Reward Type',
    selectedReferrer: 'Selected Referrer: ',
    sumOfEarnings: 'Sum of Earnings: ',
    referrer: 'Referrer',
    earnings: 'Earnings',
    operator: 'Updated By',
    payDate: 'Transferred Date'
  },
  btn: {
    outReward: 'Transfer',
    export: 'Export'
  },
  message: {
    confirmPayRewardTip: 'Confirm to transfer?',
    confirmPayRewardType: 'He/She/They is(are) paid by {rewardType}.',
    confirmPayRewardAllType: 'These are all un-paid referrers, please ensure these referrers have been exported.',
    confirmPayRewardContent: 'Are you sure you want to transfer the referrer(s)?',
    endDateAfterStartDate: 'From time must before end time!',
    payRewardSuccess: 'Transfer Success!'
  },
  ALLOCATE_MAP: {
    PENDING: 'Pending',
    TRANSFERRED: 'Transferred'
  },
  REWARD_TYPE_MAP: {
    CASH: 'Cash',
    POINTS: 'Points',
    PAYROLL: 'Payroll'
  }
}
